import type { ReviewListResponsePagination } from './reviewListResponsePagination';
import type { ReviewListResponseReviewsItem } from './reviewListResponseReviewsItem';

export interface ReviewListResponse {
  /** 페이지네이션 정보 */
  pagination: ReviewListResponsePagination;
  /** 조회된 리뷰 목록 */
  reviews: ReviewListResponseReviewsItem[];
}
